import { ProfessionIcon } from './profession-icon';

export const IconDesigner = () => (
  <ProfessionIcon bg="#FCE4EC">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2L2 7l10 5 10-5-10-5z"
        stroke="#E91E63"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M2 17l10 5 10-5"
        stroke="#E91E63"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12l10 5 10-5"
        stroke="#E91E63"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </ProfessionIcon>
);
